const CONVERSION_LABELS = {
  "louer-vendre": "AW-18141889039/4L80CI2Rz5QdEI-E3cpD",
  colocation: "AW-18141889039/der8CJCRz5QdEI-E3cpD",
  "cash-flow": "AW-18141889039/ogYoCOnx_J0dEI-E3cpD",
  rentabilite: "AW-18141889039/ehlmCOzx_J0dEI-E3cpD",
};

const META_CONTENT_NAMES = {
  "louer-vendre": "louer-vendre",
  colocation: "colocation",
  "cash-flow": "cash-flow",
  rentabilite: "tri-rendement",
};

export function trackLead(simulateur) {
  if (typeof window.gtag === "function" && CONVERSION_LABELS[simulateur]) {
    window.gtag("event", "conversion", { send_to: CONVERSION_LABELS[simulateur] });
  }
  if (typeof window.fbq === "function" && META_CONTENT_NAMES[simulateur]) {
    window.fbq("track", "Lead", { content_name: META_CONTENT_NAMES[simulateur] });
  }
}

export const CONSENT_KEY = "assertimmo_consent";

export function grantConsent() {
  if (typeof window.gtag === "function") {
    window.gtag("consent", "update", {
      ad_storage: "granted",
      ad_user_data: "granted",
      ad_personalization: "granted",
      analytics_storage: "granted",
    });
  }
  if (typeof window.fbq === "function") window.fbq("consent", "grant");
}
